import { registerPlugin } from '@capacitor/core';
const DontKillMyApp = registerPlugin('DontKillMyApp', {
    web: () => import('./web').then(m => new m.DontKillMyAppWeb()),
});
export * from './definitions';
export { DontKillMyApp };
//# sourceMappingURL=index.js.map